module.exports = {"headline":"Today I'm Even Better&trade;","button":{"text":"פרויקט מיוחד"}}


//////////////////
// WEBPACK FOOTER
// ./src/api/Welcome.json
// module id = 48
// module chunks = 0